function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\r\n\t.glassst0{fill:#B7B7B7;}\r\n\t.glassst1{fill:#C4C4C4;}\r\n\t.glassst2{fill:#CECECE;}\r\n\t.glassst3{fill:#B7B7B7;stroke:#CECECE;stroke-width:4.0591;stroke-miterlimit:10;}\r\n\t.glassst4{fill:#87171A;}\r\n\t.glassst5{fill:#6C0D0F;}\r\n");

var _ref3 =
/*#__PURE__*/
React.createElement("ellipse", {
  className: "glassst0",
  cx: 297.27,
  cy: 751.11,
  rx: 164.85,
  ry: 32.58
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "glassst1",
  d: "M340.53,421.46h-41.32h-31.02h-10.3c0,0,26.92,83.1,26.92,164.03s-6.09,154.76-6.09,154.76 s1.93,15.78,20.49,15.98c18.55-0.2,20.49-15.98,20.49-15.98s-6.09-73.84-6.09-154.76S340.53,421.46,340.53,421.46z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "glassst2",
  d: "M459.68,72.38l-163.01-2.04l0,0l-167.54-1.02c-42.89,211.4,94.17,337.85,114.88,349.86 c0.8,0.51,1.69,1,2.67,1.48c0.36,0.19,0.55,0.28,0.55,0.28h0.02c10.3,4.87,28.98,8.12,50.33,8.12s40.03-3.25,50.33-8.12h0.15 C348.05,420.94,517.72,287.87,459.68,72.38z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("ellipse", {
  className: "glassst3",
  cx: 293.62,
  cy: 72.56,
  rx: 164.35,
  ry: 30.13
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "glassst8",
  d: "M152.71,261.06c23.5,93.11,81.15,132.46,94.99,140.73c0.76,0.49,1.59,0.97,2.51,1.44 c0.34,0.18,0.52,0.27,0.52,0.27h0.02c9.69,4.72,27.27,7.88,47.35,7.88s37.66-3.16,47.35-7.88h0.14c0,0,71.23-36.26,98.03-142.44 H152.71z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("ellipse", {
  className: "glassst7",
  cx: 298.13,
  cy: 260.75,
  rx: 145.42,
  ry: 30.13
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "glassst2",
  d: "M317.47,458.92c5.36-11.92,10.25-22.4,11.87-25.87c-7.74,2.35-17.57,3.75-28.27,3.75 c-0.58,0-1.16-0.01-1.73-0.02c-0.58,0.01-1.15,0.02-1.73,0.02c-10.71,0-20.53-1.41-28.27-3.75c1.63,3.48,6.51,13.95,11.87,25.87 c2.83,9.38,6.7,22.96,8.05,31.23c2.17,23.05,5.48,66.38,4.8,110.92c-0.99,65.27-6.58,139.21-6.58,139.21s1.13,5.61,10.55,4.08 c0.36-0.06,0.69-0.1,1.03-0.15c0.09,0.01,0.18,0.03,0.27,0.04c0.09-0.01,0.18-0.03,0.27-0.04c0.34,0.05,0.67,0.09,1.03,0.15 c9.42,1.53,10.55-4.08,10.55-4.08s-5.58-73.94-6.58-139.21c-0.68-44.53,2.63-87.87,4.8-110.92 C310.77,481.88,314.64,468.31,317.47,458.92z"
});

var SvgKieliszek = function SvgKieliszek(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 841.89",
    style: {
      enableBackground: "new 0 0 595.28 841.89"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKieliszek, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kieliszek.9032c533.svg";
export { ForwardRef as ReactComponent };